const translations = {
    started: 'Started'
};

export default translations;
